import React from "react";
import { connect } from "react-redux";
import { DashboardHeader } from "../../components/Header";
import language from "../../language";
import InvoicePreview from "../../components/Invoice/preview/InvoicePreview";
import { CenterLayout } from "../../Layout";
import { TermsAndCondition } from "../../components/TermsAndCondition";

class InvoicePreviousScreen extends React.Component {
  render() {
    return (
      <CenterLayout>
        <div className="row" style={{ width: "100%" }}>
          <InvoicePreview />
          <TermsAndCondition />
        </div>
      </CenterLayout>
    );
  }
}

const mapStateToProps = (state) => {
  const { defaultLanguage } = state.Language;
  return {
    defaultLanguage,
  };
};

export default connect(mapStateToProps)(InvoicePreviousScreen);
